module.exports = __webpack_public_path__ + "img/common-logo.09d2822d.png";